import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routes } from './merge-customers.routing';
import {RouterModule} from '@angular/router';
import {MergeCustomersComponent} from './merge-customers.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {LoadingModule} from 'ngx-loading';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPermissionsModule} from 'ngx-permissions';
import {PipesModule} from '../pipes/pipes.module';
import {MaterialModule} from '../material/material.module';
import {TableModule} from 'primeng/table';
import {MatAutocompleteModule} from '@angular/material';
import {ConfirmDialogModule} from 'primeng/primeng';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import { MergeConfirmationModalComponent } from './merge-confirmation-modal/merge-confirmation-modal.component';

@NgModule({
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxDatatableModule,
    FormsModule,
    NgMultiSelectDropDownModule,
    LoadingModule,
    NgbModule,
    NgxPermissionsModule.forChild(),
    RouterModule.forChild(routes),
    PipesModule,
    MaterialModule,
    TableModule,
    MatAutocompleteModule,
    ConfirmDialogModule,
    NgxMatSelectSearchModule
  ],
  declarations: [MergeCustomersComponent, MergeConfirmationModalComponent]
})
export class MergeCustomersModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/merge-customers/merge-customers.module.ts